// Board / leadership — the single source of truth, rendered by both the About
// page (with photos) and the Contact page (names only). Edit here to update the
// board everywhere at once. See docs/EDITING.md ("Update the board / leadership").
//
// `image` is a path under public/ and is used only on the About page.
export const leadership = [
  { role: 'President', name: 'Daphne Scarbrough', image: '/images/people/DaphneScarborough.jpg' },
  { role: 'Past President', name: 'Ann Dunphy Becker', image: '/images/people/Becker Headshot.jpeg' },
  { role: 'First Vice President', name: 'Dale Cover', image: '/images/people/Dale Cover Booth.jpeg' },
  { role: 'Second Vice President', name: 'Stephen Tompkins', image: '/images/people/Stephen Tompkins.png' },
  { role: 'Secretary', name: 'Nancy Clinton', image: '/images/people/nancy-clinton_Headshot.jpg' },
  { role: 'Treasurer', name: 'Julie Sparks', image: '/images/people/Julie Sparks.png' },
  { role: 'Historian', name: 'Terry Hebert', image: '/images/people/Terry Hebert.JPG' },
  { role: 'Curator', name: 'Lee Benner', image: '/images/people/Lee Benner.jpeg' },
];
